<template>
	<div class="module-page">
		<Card class="upload-card">
			<Form ref="searchForm" :model="searchForm" inline style="text-align: left;margin-top: 1%; width: 100%;">
				<FormItem label="充电站:" :label-width="70" prop="StationId">
					<Select filterable placeholder="站点列表" style="width: 150px;" v-model="searchForm.StationId">
						<Option :value="0">全部</Option>
						<Option v-for="item in StationList" :key="item.StationId" :value="item.StationId">
							{{item.StationName}}
						</Option>
					</Select>
				</FormItem>
				<FormItem prop="EquipmentNo">
					<Input style="width: 180px;" type="text" v-model="searchForm.EquipmentNo" placeholder="设备编号">
						<span slot="prepend">设备编号</span>
					</Input>
				</FormItem>
				<FormItem prop="EquipmentSerialNo">
					<Input style="width: 180px;" type="text" v-model="searchForm.EquipmentSerialNo" placeholder="设备序列号">
						<span slot="prepend">设备序列号:</span>
					</Input>
				</FormItem>
				<FormItem>
					<Button type="primary" @click="handleSubmitList">查询</Button>
				</FormItem>
			</Form>
		</Card>
		<Card title="模块信息列表" style="margin-top: 8px;">
			<Table :columns="tableColumns" :data="tableData" stripe border row-key="Id" :height="tableHeight">
				<MyPage slot="footer" ref="sonPageList" :param="searchForm" :url="getPowerModuleRecordUrl" @listData='getModuleList'>
				</MyPage>
			</Table>
		</Card>
	</div>
</template>
<script>
//import expandRow from './Template/ModuleExpand.vue';
import { mapState } from 'vuex'
import webapi from '../../../webapi';
export default {
	name: 'ModuleInfo',
	computed: {
		...mapState({
			StationList: 'Stations',
		})
	},
	mounted() {
		//this.SelectParam = this.$refs.MyTerm.formInline
		this.$nextTick(() => {
			// this.handleSubmitFile();
			this.handleSubmitList();
		})
	},
	created() {
		const _this = this;
		// _this.tableHeight = window.innerHeight - 220;
		_this.getTableHeight();
		window.addEventListener('resize', this.getTableHeight)
	},
	destroyed() {
		window.removeEventListener("resize", this.getTableHeight);
	},

	data() {
		return {
			getPowerModuleRecordUrl: webapi.base_api_url + '/Operations/GetPowerModuleRecord',
			searchForm: {
				StationId: 0,
				EquipmentNo: '',
				EquipmentSerialNo: '',
			},
			tableHeight: "650",
			tableColumns: [
				// {
				// 	type: 'expand',
				// 	width: 50,
				// 	render: (h, params) => {
				// 		return h(expandRow, {
				// 			props: {
				// 				row: params.row
				// 			}
				// 		})
				// 	}
				// },
				{
					type: 'index',
					// key: 'index',
					width: 80
				},
				{
					title: '设备序列号',
					key: 'EquipSerialNo',
					width: 120,
					// fixed: 'left'
				},
				{
					title: '模块地址',
					key: 'ModuleAddr',
					width: 95,
					// fixed: 'left'
				},
				{
					title: '模块状态',
					key: 'ModuleStatus',
					width: 95,
					render: (h, params) => {
						const val = params.row.ModuleStatus;
						return h('Tag', {
							props: {
								color: val === 1 ? 'success' : 'default'
							}
						}, val === 1 ? '开机' : '关机');
					}
				},
				{
					title: '设置电压(V)',
					key: 'SetVoltage',
					width: 115
				},
				{
					title: '设置电流(A)',
					key: 'SetCurrent',
					width: 115
				},
				{
					title: '输出电压(V)',
					key: 'OutputVoltage',
					width: 115
				},
				{
					title: '输出电流(A)',
					key: 'OutputCurrent',
					width: 115
				},
				{
					title: '模块温度(℃)',
					key: 'ModuleTemp',
					width: 120
				},
				{
					title: '所属分组',
					key: 'ModuleGroup',
					width: 95
				},
				{
					title: '组内模块数',
					key: 'ModuleNumInGroup',
					width: 110
				},
				{
					title: '分配终端号',
					key: 'SwitchTo',
					width: 110
				},
				
				{
					title: '模块类型',
					key: 'ModuleType',
					width: 95
				},
				{
					title: '故障码',
					key: 'FaultCode',
					width: 80
				},
				
				{
					title: '上报时间',
					key: 'ReportTime',
					minWidth: 170
				},
			],
			tableData: []
		};
	},
	methods: {
		getModuleList(data) {
			this.tableData = data.Data.List;
		},
		handleSubmitList() {
			this.$refs.sonPageList.getList();
		},
		getTableHeight: function() {
			this.tableHeight = window.innerHeight - 265;
			if (window.innerWidth < 872) {
				this.tableHeight -= 56;
			}
			// if (window.innerWidth < 1017) {
			// 	this.tableHeight -= 53;
			// }
			if (window.innerWidth < 610) {
				this.tableHeight -= 56;
			}
		},
	}
};
</script>
<style scoped>
	.desc-container {
		padding: 16px 24px;
		background: #fafafa;
	}
	.desc-item {
		margin: 8px 0;
		font-size: 14px;
	}
	.label {
		color: #666;
		display: inline-block;
		width: 140px;
	}
</style>
